// src/modules/Caregaps2/dialogs/EvidenceDialog.jsx
import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
} from "@mui/material";

export default function EvidenceDialog({ open, onClose, onConfirm, item }) {
  const [codes, setCodes] = React.useState("");
  const [note, setNote] = React.useState("");

  React.useEffect(() => {
    if (!open) {
      setCodes("");
      setNote("");
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm?.({ codes, note, item });
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Submit To AVALITY {item?.careGapName}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Title"
            value={codes}
            onChange={(e) => setCodes(e.target.value)}
          />
          <TextField
            label="Note"
            multiline
            minRows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleConfirm}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
